module.exports = __webpack_public_path__ + "static/media/EmbeddedCryptography.49e42176.png";